import { render, staticRenderFns } from "./vessel-detail-chat.vue?vue&type=template&id=47de0fdc&scoped=true"
import script from "./vessel-detail-chat.vue?vue&type=script&lang=js"
export * from "./vessel-detail-chat.vue?vue&type=script&lang=js"
import style0 from "./vessel-detail-chat.vue?vue&type=style&index=0&id=47de0fdc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47de0fdc",
  null
  
)

export default component.exports